// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"350":"72a30a16","687":"fe75db45"}[chunkId] || chunkId) + "." + {"350":"b81ad39e9cae42b2","385":"ecf6835451fdb8e0","424":"3242db8a20955504","687":"b1a07b8feb0fd57f"}[chunkId] + ".js";
};